import { RechartsTheme } from './RechartsTheme';

/**
 * Light mode theme
 *
 * @experimental - this is still in active development, assume that the API will change in a minor/patch version
 */
export const lightTheme: RechartsTheme = {
  grid: {
    stroke: '#d6d3d1',
    fill: 'none',
  },
};
